enum SpeakerEventType {
  Added = 'speaker_added',
  Updated = 'speaker_updated',
  Removed = 'speaker_removed',
}

enum JoinToSpeakEventType {
  Approved = 'join_to_speak_approved',
  Denied = 'join_to_speak_denied',
  Expired = 'join_to_speak_expired',
}

export { SpeakerEventType, JoinToSpeakEventType }
